import { cn } from "@/lib/utils";
import { PlusIcon } from "lucide-react";


type BanTemplatesListAddButtonProps = {
    onClick: () => void;
    disabled: boolean;
}

export default function BanTemplatesListAddButton({ onClick, disabled }: BanTemplatesListAddButtonProps) {
    return (
        <li
            onClick={onClick}
            className={cn(
"pressable min-h-11 rounded-tile border border-edge bg-tile px-3 py-2 flex items-center gap-3",
                "font-rad text-caption font-semibold uppercase tracking-[.12em] text-dim scrim",
                disabled ? "opacity-40 cursor-not-allowed" : "hover:border-accent/45 hover:bg-accent/10 hover:text-accent cursor-pointer"
            )}
        >
            <PlusIcon className="size-4 shrink-0 drop-scrim" />
            <span>Add New Reason</span>
        </li>
    )
}
